import * as yup from 'yup';

import i18n from '../../../../i18n';
import { pkValidation } from '../../../../utils/pkValidation';
import { PK_FORMAT_REGEX } from '../../../../utils/transform';

/**
 * Validación de la plantilla, espejo de la del asistente
 * (`NewRoute/schema.ts`): mismo formato de PK y mismo test contra los extremos
 * de SU carretera, porque `this.parent` dentro del item de un array ES la fila.
 *
 * 🔴 NO se exige `pkInit < pkEnd`: el turno de vuelta va de PK mayor a menor
 * (164 → 82) y es tan válido como el de ida. El backend tampoco lo exige.
 */
const pkField = () =>
  yup
    .string()
    .matches(PK_FORMAT_REGEX, () => i18n.t('validation:pk.format'))
    .test('pk-validation', function (value) {
      if (
        PK_FORMAT_REGEX.test(value || '') &&
        pkValidation(value || '', this.parent)
      ) {
        return true;
      }
      return this.createError({ message: i18n.t('validation:pk.validation') });
    })
    .required(() => i18n.t('validation:required'));

export const routePresetSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .min(1, () => i18n.t('validation:required'))
    .required(() => i18n.t('validation:required')),
  roadIds: yup
    .array()
    .of(yup.string().required())
    .min(1, () => i18n.t('validation:required'))
    .required(() => i18n.t('validation:required')),
  roadRanges: yup
    .array()
    .of(
      yup.object().shape({
        roadId: yup.string().required(() => i18n.t('validation:required')),
        pkInitRoad: yup.string().required(() => i18n.t('validation:required')),
        pkEndRoad: yup.string().required(() => i18n.t('validation:required')),
        pkInit: pkField(),
        pkEnd: pkField(),
      })
    )
    .min(1, () => i18n.t('validation:required'))
    .required(() => i18n.t('validation:required')),
});
